module.exports = __webpack_public_path__ + "img/tick-white.d251ad60.svg";